module.exports = __webpack_public_path__ + "img/group-cards.8ea99970.png";